module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tipo de acréscimo",
      "columns": 2
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.additionType),
      expression: "newItem.additionType"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newItem, "additionType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Fixo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percentual")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Valor do acréscimo",
      "columns": 2
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [(_vm.newItem.additionType === 'fixed') ? _c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "type": "tel"
    },
    model: {
      value: (_vm.newItem.additionValue),
      callback: function($$v) {
        _vm.$set(_vm.newItem, "additionValue", $$v)
      },
      expression: "newItem.additionValue"
    }
  }, 'money', _vm.money, false)) : _vm._e(), _vm._v(" "), (_vm.newItem.additionType === 'percent') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.additionValue),
      expression: "newItem.additionValue"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newItem.additionValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "additionValue", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newItem.additionType === 'percent') ? _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("%")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "De",
      "columns": 2
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "type": "tel"
    },
    model: {
      value: (_vm.newItem.from.minRange),
      callback: function($$v) {
        _vm.$set(_vm.newItem.from, "minRange", $$v)
      },
      expression: "newItem.from.minRange"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Até",
      "columns": 2
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "type": "tel"
    },
    model: {
      value: (_vm.newItem.to.maxRange),
      callback: function($$v) {
        _vm.$set(_vm.newItem.to, "maxRange", $$v)
      },
      expression: "newItem.to.maxRange"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e0cbb66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/skyhub/AdditionAddItem.vue
// module id = 3327
// module chunks = 0